import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import Cartesian from './cartesian';
import { _manageLegendSpace as _manageLegendSpace2, manageGradientLegendSpace as _manageGradientLegendSpace } from '../../_internal/common-chart-api/legend-spacemanager';
import datasetFactory from '../../factories/multiseries-dataset';
import legendItemFactory from '../../factories/legend';

var MSCartesian =
/*#__PURE__*/
function (_Cartesian) {
  _inherits(MSCartesian, _Cartesian);

  function MSCartesian() {
    var _this;

    _classCallCheck(this, MSCartesian);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MSCartesian).call(this)), _this.registerFactory('dataset', datasetFactory, ['vCanvas']), _this.registerFactory('legend', legendItemFactory);
    return _this;
  }

  _createClass(MSCartesian, [{
    key: "getName",
    value: function getName() {
      return 'MSCartesian';
    }
  }, {
    key: "getType",
    value: function getType() {
      return 'chartAPI';
    }
  }, {
    key: "_createLayers",
    value: function _createLayers() {
      _get(_getPrototypeOf(MSCartesian.prototype), "_createLayers", this).call(this);

      var a = this.getFromEnv('animationManager');
      this.getChildContainer('legendGroup') || this.addChildContainer('legendGroup', a.setAnimation({
        el: 'group',
        attr: {
          name: 'legend'
        },
        component: this,
        container: this.getContainer('parentgroup'),
        label: 'group'
      }));
    }
  }, {
    key: "_manageLegendSpace",
    value: function _manageLegendSpace() {
      _manageLegendSpace2.call(this);
    }
  }, {
    key: "manageGradientLegendSpace",
    value: function manageGradientLegendSpace(a) {
      return _manageGradientLegendSpace.call(this, a);
    }
  }], [{
    key: "getName",
    value: function getName() {
      return 'MSCartesian';
    }
  }]);

  return MSCartesian;
}(Cartesian);

export default MSCartesian;